import React, {Component} from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {Tab, Tabs} from '@material-ui/core';
import "../assets/tournament.css"
import Calendar from '../pages/calendar';
import {withNamespaces} from 'react-i18next';
import i18n from '../i18n';
import moment from 'moment';
import RenderPdf from '../components/render-pdf'
import httpRequest, {url} from '../components/request-api'
import * as _ from "lodash";

class Tournament extends Component {
    constructor(props) {
        super(props);
        this.state = {
            setToggle: true,
            tournament: [],
            preload: false,
            event: [],
            tournamentAll: [],
            activeTabIndex: 0,
            responsibility: {}
        };
        this.changeLanguage(this.props.match.params.lang)
    }

    tournament = async (type) => {
        this.setState({
            preload: true
        })
        await httpRequest.tournament(type).then(result => {
            if (type === "central_junior_tour") {
                this.setData(result.data.result)
            } else if (type === "regional_junior_tour") {
                this.setState({
                    tournamentAll: result.data.result,
                    // responsibility: result.data.result.upper_north.responsibility
                })
                this.setData(result.data.result.upper_north.tournaments)
            } else if (type === "open_tournament") {
                this.setState({
                    tournamentAll: result.data.result,
                    // responsibility: result.data.result.central_lower.responsibility
                })
                this.setData(result.data.result.central_lower.tournaments)
            } else if (type === "national_team") {
                this.setState({
                    tournamentAll: result.data.result
                })
                this.setData(result.data.result.domestic)
            }
        }).catch(error => {
            this.setState({
                preload: false
            })
            console.log(error);
        })
    }

    selectdata = (sector, type) => {
        if (type === "national_team") {
            this.setData(this.state.tournamentAll[sector])
            this.setState({
                // responsibility: this.state.tournamentAll[sector].responsibility
            })
        } else {
            if (typeof this.state.tournamentAll !== "undefined") {
                this.setData(this.state.tournamentAll[sector].tournaments)
                this.setState({
                    // responsibility: this.state.tournamentAll[sector].responsibility
                })
            }

        }
    }


    setData = (data) => {
        this.groupByMonth(data).then((res) => {
            this.eventSet(data).then((event) => {
                const year = new Date().getFullYear()

                if (res.hasOwnProperty(year)) {
                    this.setState({
                        event: event,
                        tournament: res[year],
                        preload: false
                    })
                } else {
                    this.setState({
                        event: event,
                        tournament: [],
                        preload: false
                    })
                }
            })
        })
    }

    handleChange = (event, value) => {
        this.setState({activeTabIndex: value});
    };

    async eventSet(data) {
        let event = []

        _.groupBy(data, function (element) {
            var d = moment(element.end_date).add(1, 'days')._d
            event.push({
                data: element,
                title: element.name_en,
                start: element.start_date,
                end: moment(d).format('YYYY-MM-DD'),
                color: '#5485D2'
            });
        });

        return event
    }

    async groupByMonth(data) {
        const orderedByMonths = _.groupBy(data, function (element) {
            return element['start_date'].substring(0, 7);
        });

        return _.groupBy(orderedByMonths, function (month) {
            return month[0]['start_date'].substring(0, 4);
        })
    }

    componentDidMount() {
        this.tournament(this.props.match.params.id)
    }

    changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    }

    day(date) {
        return moment(date).format('DD/MM');
    }

    calendarTable() {
        const {t} = this.props;
        const {tournament, preload, event, responsibility} = this.state;

        const toggle = () => {
            this.setState({setToggle: !this.state.setToggle});
        }

        const handleClick = (data) => {
            var a = btoa(JSON.stringify({"result_ids": data.result_ids, "schedule_ids": data.schedule_ids}))
            this.props.history.push(`/tournament-detail/${data.id}/${localStorage.getItem("i18nextLng")}/${this.props.match.params.id}/${a}`)
        };

        return (
            <section>
                <section className="contact-info-area">

                    <div className="row">
                        {typeof responsibility.coordinator !== "undefined" ?
                            <div className="col-6">
                                <h6>ประธานอนุกรรมการ</h6>
                                <img src={`data:image/png;base64,${responsibility.coordinator.image}`} width="120px"
                                     alt="" style={{alignSelf: "center"}}/>
                                <div><p className="mb-0"> {responsibility.coordinator.name}</p>
                                    <p className="mb-0">โทร {responsibility.coordinator.phone}</p></div>
                            </div>
                            : <></>
                        }
                        {typeof responsibility.president !== "undefined" ?
                            <div className="col-6">
                                <h6>ผู้ประสานงาน</h6>
                                <img src={`data:image/png;base64,${responsibility.president.image}`} width="120px"
                                     alt="" style={{alignSelf: "center"}}/>
                                <div><p className="mb-0">{responsibility.president.name}</p>
                                    <p className="mb-0">โทร {responsibility.president.phone}</p></div>
                            </div>
                            : <></>
                        }
                    </div>
                </section>

                <section className="contact-info-area" data-background="/assets/img/gallery/section_bg04.jpg">
                    <div className="">
                        {!this.state.setToggle ?
                            <div className="text-right"><i style={{fontSize: "22px"}} onClick={() => toggle()}
                                                           class="ti-layout-media-center cursor"></i></div> :
                            <div className="text-right"><i style={{fontSize: "22px"}} onClick={() => toggle()}
                                                           class="ti-layout-media-center iconCalendar cursor"></i>
                            </div>}
                        {!this.state.setToggle ? <section></section> :
                            <>{preload ? <></> : <Calendar event={event} handleClick={handleClick.bind(this)}/>}</>}
                    </div>
                </section>


                <section className="pt-30">
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                            </TableHead>
                            {tournament.length === 0 && !preload ? <h6 className="p-5">Tournament not found.</h6> :
                                <>            {preload ?
                                    <div id="preloader-active">
                                        <div class="preloader d-flex align-items-center justify-content-center"
                                             style={{backgroundColor: "initial"}}>
                                            <div class="preloader-inner position-relative">
                                                <div class="preloader-circle"></div>
                                                <div class="preloader-img pere-text">
                                                    <img src="/assets/img/logo/TGALogo.png" alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : <>
                                        {tournament.map((item) => (
                                            <TableBody>
                                                <TableRow className="bg-gray mt-20"> <TableCell className="blue-color">
                                                    {t(`${moment(item[0].start_date).format('MMMM')}`)}
                                                </TableCell><TableCell></TableCell><TableCell> </TableCell>
                                                </TableRow>
                                                {item.map((data) => (
                                                    <TableRow onClick={() => handleClick(data)} className="cursor">
                                                        <TableCell align="left" component="th" scope="row"
                                                                   className="blue-color">
                                                            {`${this.day(data.start_date)} - ${this.day(data.end_date)}`}
                                                        </TableCell>
                                                        <TableCell className="blue-color"
                                                                   align="left">{data.name_en}</TableCell>
                                                        <TableCell className="gray-color"
                                                                   align="left">{data.course.name_en}</TableCell>
                                                    </TableRow>
                                                ))
                                                }
                                            </TableBody>
                                        ))}
                                    </>
                                }
                                </>
                            }
                        </Table>
                    </TableContainer>
                </section>
            </section>
        )
    }

    render() {
        const {t} = this.props;
        const {activeTabIndex} = this.state;

        return (
            <div id="app">
                <section className="services-area">
                    <div className="container" style={{"marginBottom": "7rem"}}>
                        <div className="project-heading mb-35">
                            <div className="row align-items-end">

                                {this.props.match.params.id === 'central_junior_tour' ?
                                    <div className="properties__button">
                                        <Tabs value={activeTabIndex} onChange={this.handleChange}>
                                            <Tab label={t('schedule')}/>
                                            <Tab label={t('scoreCalculator')}/>
                                            <Tab label={t('generalRegulation')}/>
                                            <Tab label={t('points')}/>
                                        </Tabs>
                                    </div> : <></>
                                }
                                {
                                    this.props.match.params.id === 'regional_junior_tour' ?
                                        <div className="properties__button">
                                            <Tabs value={activeTabIndex} onChange={this.handleChange}>
                                                <Tab label={t('upperNorth')}
                                                     onClick={() => this.selectdata('upper_north')}/>
                                                <Tab label={t('lowerNorth')}
                                                     onClick={() => this.selectdata('lower_north')}/>
                                                <Tab label={t('central')}
                                                     onClick={() => this.selectdata('central_region')}/>
                                                <Tab label={t('eastern')}
                                                     onClick={() => this.selectdata('eastern_region')}/>
                                                <Tab label={t('northeast')}
                                                     onClick={() => this.selectdata('northeast_region')}/>
                                                <Tab label={t('south')}
                                                     onClick={() => this.selectdata('southern_region')}/>
                                            </Tabs>
                                        </div> : <></>
                                }

                                {
                                    this.props.match.params.id === 'open_tournament' ?
                                        <div className="properties__button">
                                            <Tabs value={activeTabIndex} onChange={this.handleChange}>
                                                <Tab label={t('centralLower')}
                                                     onClick={() => this.selectdata('central_lower')}/>
                                                <Tab label={t('central')}
                                                     onClick={() => this.selectdata('central_region')}/>
                                                <Tab label={t('eastern')}
                                                     onClick={() => this.selectdata('eastern_region')}/>
                                                <Tab label={t('lowerNorth')}
                                                     onClick={() => this.selectdata('lower_north')}/>
                                                <Tab label={t('northeast')}
                                                     onClick={() => this.selectdata('northeast_region')}/>
                                                <Tab label={t('south')}
                                                     onClick={() => this.selectdata('southern_region')}/>
                                                <Tab label={t('upperNorth')}
                                                     onClick={() => this.selectdata('upper_north')}/>
                                            </Tabs>
                                        </div> : <></>
                                }

                                {
                                    this.props.match.params.id === 'national_team' ?
                                        <div className="properties__button">
                                            <Tabs value={activeTabIndex} onChange={this.handleChange}>
                                                <Tab label={t("nationTeam")}/>
                                                <Tab label={t("domesticCompetition")}
                                                     onClick={() => this.selectdata('domestic', "national_team")}/>
                                                <Tab label={t("foreignCompetition")}
                                                     onClick={() => this.selectdata('foreign', "national_team")}/>
                                                <Tab label={t("points")}/>
                                            </Tabs>
                                        </div> : <></>
                                }
                            </div>
                        </div>
                        {/*type 1 */}
                        {this.props.match.params.id === 'central_junior_tour' ?
                            <>
                                {
                                    activeTabIndex === 0 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 1 &&
                                    <div>
                                        <RenderPdf
                                            file={`${url}/tournament_category/${this.props.match.params.id}/score_calculator`}/>
                                    </div>
                                }
                                {
                                    activeTabIndex === 2 &&
                                    <div>
                                        <RenderPdf
                                            file={`${url}/tournament_category/${this.props.match.params.id}/general_regulation`}/>
                                    </div>
                                }
                                {
                                    activeTabIndex === 3 &&
                                    <div>
                                        <RenderPdf
                                            file={`${url}/tournament_category/${this.props.match.params.id}/reward_points`}/>
                                    </div>
                                }
                            </> : <></>
                        }


                        {/*type 2 */}
                        {this.props.match.params.id === 'regional_junior_tour' ?
                            <>
                                {
                                    activeTabIndex === 0 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 1 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 2 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 3 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 4 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 5 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 6 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                            </> : <></>
                        }


                        {/*type 3 */}
                        {this.props.match.params.id === 'open_tournament' ?
                            <>
                                {
                                    activeTabIndex === 0 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 1 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 2 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 3 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 4 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 5 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 6 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                            </> : <></>
                        }


                        {/*type 4 */}
                        {this.props.match.params.id === 'national_team' ?
                            <>
                                {
                                    activeTabIndex === 0 &&
                                    <div>
                                        <RenderPdf
                                            file={`${url}/tournament_category/${this.props.match.params.id}/national_team_list`}/>
                                    </div>
                                }
                                {
                                    activeTabIndex === 1 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 2 &&
                                    <div>
                                        {this.calendarTable()}
                                    </div>
                                }
                                {
                                    activeTabIndex === 3 &&
                                    <div>
                                        <RenderPdf
                                            file={`${url}/tournament_category/${this.props.match.params.id}/reward_points`}/>
                                    </div>
                                }
                            </> : <></>
                        }
                    </div>
                </section>
            </div>
        );
    }
}

export default withNamespaces()(Tournament)